import {
  LocalityAddress,
  PaymentFrequency,
  PolicyIssued,
  PostalAddress,
  YesNoAnswer,
} from 'scenes/common/types';
import { PolicyHolder } from 'scenes/motor/flows/addPolicyHolder/types';
import { VehicleModification } from 'scenes/motor/flows/coverOptions/types';
import {
  PostalAddressOption,
  TermsAndConditions,
} from 'scenes/common/flows/policyDetails/types';

export enum MotorPolicySubSection {
  InsuredSincePossessed = 'Insured since possessed',
  PreExistingDamage = 'Pre existing damage',
  VehicleModifications = 'Vehicle modifications',
  SpecialFeatures = 'Special features',
  SpecialDetails = 'Special details',
  PolicyIssuedTo = 'Policy issued to',
  PersonalPolicyContact = 'Personal policy contact',
  BusinessPolicyContact = 'Business policy contact',
  ContactPhoneNumber = 'Contact phone number',
  ContactEmailAddress = 'Contact email address',
  // eslint-disable-next-line no-shadow
  PostalAddress = 'Postal address',
  BusinessNameAndAbn = 'Business name and ABN',
  BusinessRegisteredForGst = 'Business registered for GST',
  BusinessContact = 'Business contact',
  AddPolicyHolder = 'Add policy holder',
}

export enum SpecialDetail {
  LicenceCancelled = 'LICENSEISSUES',
  InsuranceClaimRefused = 'CARINSURANCECLAIMREFUSED',
  InsurancePolicyCancelled = 'CARINSURANCEPOLICYCANCELLED',
  DeniedPurchase = 'CARINSURANCEDENIED',
  ConvictedOrFinedOrPenalised = 'DRIVINGOFFENCE',
  None = 'NONE',
}

export enum IsInsuredSincePossess {
  Yes = 'Yes',
  No = 'No',
  HaventTakenPossession = 'I haven’t taken possession of the car yet',
  Unspecified = '',
}

export const INSURED_SINCE_POSSES_OPTIONS = [
  { label: IsInsuredSincePossess.Yes, value: IsInsuredSincePossess.Yes },
  { label: IsInsuredSincePossess.No, value: IsInsuredSincePossess.No },
  {
    label: IsInsuredSincePossess.HaventTakenPossession,
    value: IsInsuredSincePossess.HaventTakenPossession,
  },
];

export interface PolicyDetailsData {
  policyIssued: PolicyIssued;
  businessName: string;
  abn: string;
  isBusinessRegisteredForGst: YesNoAnswer;
  policyHolders: PolicyHolder[];
  businessContactFirstName: string;
  businessContactLastName: string;
  personalContactFirstName: string;
  personalContactLastName: string;
  contactPhoneNumber: string;
  contactEmailAddress: string;
  postalAddressOption: PostalAddressOption;
  isPostalAddressDifferentManual?: boolean;
  overnightAddress: PostalAddress;
  lockedBoxAddress: LocalityAddress;
  postalAddress: PostalAddress;
  hasPreExistingDamage: YesNoAnswer;
  hasModifications: YesNoAnswer;
  hasSpecialFeatures: YesNoAnswer;
  specialFeatures: string;
  isInsuredSincePossessed: IsInsuredSincePossess;
  vehicleModifications: VehicleModification[];
  stereoCost: string;
  specialDetails: SpecialDetail[];
  isRegoKnown: YesNoAnswer;
  missingLicencePlate: string;
  termsAndCondition: TermsAndConditions;
  termsAndConditionForSmallBusiness: TermsAndConditions;
  preselectedPaymentFrequency: PaymentFrequency;
}
